<script setup>
import CardLayout from 'dashboard/components-next/CardLayout.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

import { overviewContent } from '../../helpers/kraftchatAIOverviewConfig';

defineProps({
  step: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['navigate']);
</script>

<template>
  <CardLayout
    class="!bg-n-solid-1 !outline-n-weak shadow-sm transition-colors hover:!outline-n-strong [&>div]:!px-5 [&>div]:!py-5"
  >
    <div class="flex flex-wrap items-start justify-between gap-4">
      <div class="flex min-w-0 items-start gap-3">
        <div
          class="grid size-9 flex-shrink-0 place-content-center rounded-lg bg-n-alpha-2 text-n-brand"
        >
          <Icon :icon="step.icon" class="size-5" />
        </div>

        <div class="min-w-0 space-y-1">
          <p
            class="text-xs font-medium uppercase tracking-wide text-n-slate-10"
          >
            {{ overviewContent.nextStepTitle }}
          </p>

          <h2 class="text-base font-semibold text-n-slate-12">
            {{ step.title }}
          </h2>

          <p class="max-w-3xl text-sm leading-6 text-n-slate-11">
            {{ step.description }}
          </p>
        </div>
      </div>

      <NextButton
        type="button"
        outline
        slate
        size="sm"
        :label="step.actionLabel"
        @click="emit('navigate', step)"
      />
    </div>
  </CardLayout>
</template>
